import { render, staticRenderFns } from "./MaterialsBankDemo.vue?vue&type=template&id=f4b48562&scoped=true"
import script from "./MaterialsBankDemo.vue?vue&type=script&lang=js"
export * from "./MaterialsBankDemo.vue?vue&type=script&lang=js"
import style0 from "./MaterialsBankDemo.vue?vue&type=style&index=0&id=f4b48562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b48562",
  null
  
)

export default component.exports